export default "__VITE_ASSET__01c54fdb__"